export const BINDER_INVALID_OPERATION = "BINDER_INVALID_OPERATION";
export const BINDER_NOT_FOUND = "BINDER_NOT_FOUND";
export const BINDER_UNAUTHORIZED_OPERATION = "BINDER_UNAUTHORIZED_OPERATION";
